/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { css as cssUnbounded } from '@compiled/react';

import { css, jsx } from '@atlaskit/css';
import { formatShortcut, type Keymap } from '@atlaskit/editor-common/keymaps';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const styleUnbounded = cssUnbounded({
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	padding: '3px',
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	marginLeft: '6px',
});

const style = css({
	borderRadius: token('border.radius.100'),

	color: token('color.text.subtle'),
	backgroundColor: token('color.background.neutral'),
	fontWeight: token('font.weight.regular'),
});

interface Props {
	/** The keymap object containing the shortcut information. */
	shortcut: Keymap;
}

/** Component that displays a formatted keyboard shortcut. */
export function Shortcut({ shortcut }: Props) {
	const formattedShortcut = formatShortcut(shortcut);

	return <span css={[style, styleUnbounded]}>{formattedShortcut}</span>;
}
